import React, {useEffect, useState} from 'react'
import {Lang} from 'yougile-lang'
import {Time} from 'yougile-util'
import {DataObjectId, Hub, isDealActivityDealItem} from 'yougile-model'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {TwIconButtonNew} from '../../../../task-card/done-button'
import {getDealActivityById} from '../get-deal-activity'

interface Props {
  activity: {id: DataObjectId; completed?: boolean}
  deal?: Hub
}

export const DealActivityDoneButton = (props: Props) => {
  const {activity, deal} = props
  const [completed, setCompleted] = useState(activity.completed)

  useEffect(() => {
    setCompleted(activity.completed)
  }, [activity.completed, deal?.id])

  if (!deal) {
    return null
  }

  const icon = completed
    ? 'IconCustomTaskDoneFilled'
    : 'IconCustomTaskDoneEmpty'

  const tooltip = completed
    ? Lang.msg.crm.rightPanel.dealHistory.markActivityUncompleted
    : Lang.msg.crm.rightPanel.dealHistory.markActivityCompleted

  return (
    <Tooltip content={tooltip}>
      <TwIconButtonNew
        icon={icon}
        onClick={e => {
          e.stopPropagation()

          const dealActivity = getDealActivityById(deal, activity.id)
          if (isDealActivityDealItem(dealActivity)) {
            const newValue = !dealActivity.completed
            dealActivity.completed = newValue
            dealActivity.completedModified = Time.now()
            deal.commit()
            setCompleted(newValue)
          }
        }}
        $isTaskColored={false}
        disabled={false}
      />
    </Tooltip>
  )
}
